import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getHasJWT } from "~/helpers/auth";

interface IProps {
  render: React.ReactNode;
  guest?: boolean;
  to?: string;
}

const RouteGuard: React.FC<IProps> = ({ render, guest = false, to }) => {
  const hasJWT = getHasJWT();
  const location = useLocation();

  if (guest ? !hasJWT : hasJWT) return <>{render}</>;
  if (!to) return null; // when implementing login, redirect to login, if "to" is not set
  if (!guest) {
    localStorage.setItem(
      "redirect_to_url_after_signin",
      `${location.pathname}${location.search}`
    );
  }

  const searchParams = new URLSearchParams(window.location.search);

  return <Navigate to={{ pathname: to, search: searchParams.toString() }} />;
};

export default RouteGuard;
